export default __webpack_public_path__ + "static/media/wealth.0271de3a.png";